import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Button, Collapse } from '@mui/material';
import Stack from '@mui/material/Stack';
import useConfig from './hooks/useConfig';
import { getAuthPortalLoginUrl } from './utils/authPortal';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import mainBanner from 'assets/images/main-banner.jpg';
import netgearLogo from 'assets/images/netgear-insight.png';
import scrollDown from 'assets/images/scroll-down.png';
import lineBg from 'assets/images/line-bg.png';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function LandingPage() {
  const { hideLoader } = useConfig();
  const [open, setOpen] = useState(true);
  const bottomRef = useRef(null);
  const handleScrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  useEffect(() => {
    hideLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function calltheAPI(loginAcc) {
    // v2 flow: redirect to auth portal (OC) for login; redirectUrl brings user back here after login
    loginAcc == 'Premium'
      ? (window.location.href = getAuthPortalLoginUrl())
      : (window.location.href = process.env.camSdkRedirectUrl + '#/register');
  }
  return (
    <Box id="landingPage">
      <Box
        id="banner_block"
        position={'relative'}
        className={!open ? 'hasCollapse' : ''}
        sx={{
          backgroundImage: `url(${mainBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
          minHeight: { xs: '400px', lg: '610px' }
        }}
      >
        <Box
          id="banner_blockBody"
          flexDirection={'column'}
          display={'flex'}
          justifyContent={'center'}
          py={3.75}
          sx={{
            maxWidth: '490px',
            height: '100%',
            marginLeft: { xs: '20px', md: '60px' },
            color: 'white.paper'
          }}
        >
          <Box id="banner_text" position={'relative'}>
            <img src={netgearLogo} alt="Netgear-logo" id="netgear_logo" width="124" height="30" />
            <Collapse in={open}>
              <Box id="bannerTextCollapse">
                <Typography
                  variant="h1"
                  id="banner_heading"
                  sx={{
                    color: 'white.paper',
                    fontWeight: 'normal',
                    marginTop: { xs: '15px', lg: '25px' },
                    marginBottom: { xs: '10px', lg: '20px' }
                  }}
                >
                  Easily Manage Networks Remotely
                </Typography>
                <Typography
                  component="p"
                  variant="body1"
                  id="banner_desc0"
                  sx={{
                    marginBottom: { xs: '16px', lg: '20px' },
                    fontSize: '20px'
                  }}
                >
                  Deploy, monitor and manage your network. Anytime, anywhere.
                </Typography>
                <Typography
                  component="p"
                  variant="body1"
                  id="banner_desc1"
                  sx={{
                    marginBottom: { xs: '16px', lg: '30px' },
                    fontSize: '20px',
                    lineHeight: '30px'
                  }}
                >
                  NETGEAR Insight is the easy-to-use solution for delivering centralized remote cloud management of networks across multiple
                  locations for small business owners, IT managers, MSPs and VARs all from a single pane-of-glass on any device.
                </Typography>
                <Typography
                  component="p"
                  variant="body1"
                  id="banner_desc2"
                  sx={{
                    marginBottom: { xs: '16px', lg: '30px' },
                    fontSize: '20px',
                    lineHeight: '30px'
                  }}
                >
                  To get started, create Insight account
                  <Button
                    variant="outlined"
                    id="signupNow"
                    onClick={() => setOpen(!open)}
                    color="white.paper"
                    sx={{
                      marginLeft: '20px',
                      borderRadius: '7px',
                      fontWeight: 'normal',
                      padding: '3px 11px'
                    }}
                    endIcon={<ArrowRightAltIcon />}
                  >
                    Signup Now
                  </Button>
                </Typography>
                <Typography
                  component="p"
                  variant="body1"
                  id="banner_desc2"
                  sx={{
                    marginBottom: { xs: '16px', lg: '30px' },
                    fontSize: '20px',
                    lineHeight: '30px'
                  }}
                >
                  If you already have an Insight account
                  <Button
                    variant="contained"
                    id="loginNow"
                    sx={{
                      marginLeft: '16px',
                      borderRadius: '7px',
                      fontWeight: 'normal',
                      padding: '4px 16px',
                      bgcolor: 'white.paper',
                      color: 'purple.300'
                    }}
                    endIcon={<ArrowRightAltIcon />}
                    onClick={() => calltheAPI('Premium')}
                  >
                    Login Now
                  </Button>
                </Typography>
                <Typography
                  component="p"
                  variant="body1"
                  id="banner_desc3"
                  sx={{
                    marginBottom: { xs: '10px' },
                    fontSize: '20px',
                    lineHeight: '30px'
                  }}
                >
                  To learn more{' '}
                  <a style={{ color: '#fff', fontWeight: '500' }} href="https://www.netgear.com/business/services/insight/" target="_blank">
                    Click here
                  </a>
                </Typography>
              </Box>
            </Collapse>
          </Box>
        </Box>
        <Box id="notiGroup" sx={{ position: 'relative' }}>
          {open && (
            <Box
              id="section_scroll"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '-50px',
                position: 'absolute',
                left: '0',
                right: '0'
              }}
            >
              <Box
                id="scroll_icon"
                onClick={handleScrollToBottom}
                sx={{
                  bgcolor: 'purple.300',
                  borderRadius: '100%',
                  position: 'relative',
                  padding: '8px 0 22px',
                  textAlign: 'center',
                  width: '70px',
                  cursor: 'pointer'
                }}
              >
                <img class="vertical-move" src={scrollDown} alt="scroll-down" />
              </Box>
            </Box>
          )}
          <Box id="premium_Scroll" sx={{ width: '100%', marginTop: '25px', position: 'absolute' }}>
            <Box id="container" sx={{ margin: 'auto', maxWidth: '1026px' }} ref={bottomRef}>
              <Box className="bannerLandingPage" id="landing" display={'flex'} alignItems={'start'}>
                {!open && (
                  <Typography
                    component="p"
                    variant="body1"
                    id="goBack"
                    sx={{
                      margin: '0',
                      fontSize: '18px',
                      width: '30%',
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                      color: 'white.paper',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <ArrowBackIcon sx={{ marginRight: '5px' }} fontSize="small" />
                    <Typography
                      component="span"
                      onClick={() => setOpen(true)}
                      sx={{ fontSize: '18px', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      Go Back
                    </Typography>
                  </Typography>
                )}
                <Typography
                  variant="h3"
                  id="banner_heading"
                  className="pagetitle"
                  sx={{
                    color: 'purple.300',
                    fontWeight: 'normal',
                    fontSize: '22px',
                    textAlign: 'center',
                    width: '100%',
                    textTransform: 'uppercase'
                  }}
                >
                  Compare & Choose an account to sign up
                </Typography>
              </Box>
              <Box
                className="subscriptionWrapper"
                id="container_table"
                sx={{ borderRadius: '50px', padding: '0 50px', backgroundColor: '#FDF4FF' }}
              >
                <Box className="subscriptionTalbe" id="subscription_table">
                  <table id="subscription_talbe">
                    <tr>
                      <th width="337">
                        <Box className="d-flex insightTitle justify-content-center" id="supported_features" mt={1.3}>
                          <Typography
                            variant="h4"
                            id="banner_heading"
                            sx={{
                              fontWeight: '500',
                              fontSize: '22px',
                              color: 'purple.300',
                              margin: '0'
                            }}
                          >
                            Supported Features
                          </Typography>
                        </Box>
                      </th>
                      <td width="353" className="text-center backPurpleGray">
                        <Box className="d-flex insightTitle justify-content-center" id="premium_head" mt={1.3}>
                          <Typography
                            variant="h4"
                            id="banner_heading"
                            sx={{
                              fontWeight: '500',
                              fontSize: '22px',
                              color: 'purple.300',
                              margin: '0'
                            }}
                          >
                            Premium
                          </Typography>
                        </Box>
                      </td>
                      <td width="363">
                        <Box className="d-flex insightTitle justify-content-center" id="pro_head" mt={1.3}>
                          <Typography
                            variant="h4"
                            id="banner_heading"
                            sx={{
                              fontWeight: '500',
                              fontSize: '22px',
                              color: 'purple.300',
                              margin: '0'
                            }}
                          >
                            Pro
                          </Typography>
                        </Box>
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Ideal Deployment</th>
                      <td className="text-center backPurpleGray">Multi-location / single business, remote workforce</td>
                      <td>Custom Installers, MSP, VAR, branch offices, remote workforce</td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Multi-network Location</th>
                      <td className="text-center backPurpleGray">
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Multi-tenancy</th>
                      <td className="text-center backPurpleGray">
                        <CloseIcon fontSize="medium" sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Multiple Admins</th>
                      <td className="text-center backPurpleGray">
                        <CloseIcon sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Bulk Device Onboarding</th>
                      <td className="text-center backPurpleGray">
                        <CloseIcon sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Mobile Hotspot Management</th>
                      <td className="text-center backPurpleGray">
                        <CloseIcon sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Custom Reports</th>
                      <td className="text-center backPurpleGray">
                        <CloseIcon sx={{ color: 'purple.300' }} />
                      </td>
                      <td>
                        <CheckIcon sx={{ color: 'purple.300' }} />
                      </td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Annual Billing Cost For Subscription</th>
                      <td className="text-center backPurpleGray">$9.99 ($0.83 per device per month)</td>
                      <td>$22.00 ($1.83 per device per month)</td>
                    </tr>
                    <tr>
                      <th className="text-uppercase">Free Trial</th>
                      <td className="backPurpleGray">30-day trial, 10 devices</td>
                      <td>3-month trial, 25 devices</td>
                    </tr>
                    <tr>
                      <th></th>
                      <td id="subscribe_button_block1" className="backPurpleGray">
                        <Box id="subscribe_button_block1">
                          <Button
                            variant="contained"
                            id="loginNow"
                            sx={{
                              borderRadius: '7px',
                              fontWeight: 'normal',
                              padding: { xs: '5px 10px', md: '6px 20px' },
                              bgcolor: 'purple.300',
                              color: 'white.paper',
                              fontSize: { xs: '14px', md: '16px' },
                              lineHeight: { xs: '15px', sm: '30px' }
                            }}
                            onClick={() => calltheAPI('Pro')}
                          >
                            Premium Sign-Up
                          </Button>
                        </Box>
                      </td>
                      <td>
                        <Box id="subscribe_button_block0" className="buttonBlock">
                          <Button
                            variant="contained"
                            id="loginNow"
                            sx={{
                              borderRadius: '7px',
                              fontWeight: 'normal',
                              padding: { xs: '5px 10px', md: '6px 20px' },
                              bgcolor: 'purple.300',
                              color: 'white.paper',
                              fontSize: { xs: '14px', md: '16px' },
                              lineHeight: { xs: '15px', sm: '30px' }
                            }}
                            onClick={() => calltheAPI('Pro')}
                          >
                            Pro Sign-Up
                          </Button>
                        </Box>
                      </td>
                    </tr>
                  </table>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        id="section_block"
        className="SectionBlock"
        sx={{
          backgroundImage: `url(${lineBg})`,
          backgroundSize: 'contain',
          backgroundPosition: '0 center',
          backgroundRepeat: 'repeat-x',
          paddingBottom: '50px',
          minHeight: '945px',
          backgroundColor: 'purple.100'
        }}
      ></Box>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'flex-end',
          py: 3,
          mt: 'auto',
          pr: 3
        }}
      >
        <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'flex-end' }}>
          &copy; 1996 - 2025 NETGEAR &reg;
        </Stack>
      </Stack>
    </Box>
  );
}
export default LandingPage;
